import { useQuery } from 'react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

type UseDownloadQuoteZipParams = {
  filePath: string;
};
type DownloadQuoteZipQueryKey = readonly [
  'downloads',
  'downloadQuoteZip',
  UseDownloadQuoteZipParams,
];
type DownloadQuoteZipData = {
  downloadUrl: string;
};
const getDownloadQuoteZipQueryKey = (
  params: UseDownloadQuoteZipParams,
): DownloadQuoteZipQueryKey => {
  return ['downloads', 'downloadQuoteZip', params];
};

export const useDownloadQuoteZip: QueryFunction<
  DownloadQuoteZipData,
  [UseDownloadQuoteZipParams],
  DownloadQuoteZipQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  const queryKey = getDownloadQuoteZipQueryKey(params);
  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(params.filePath, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
